<template lang="pug">
  b-modal#addUser(
    ref="addUser"
    :title="$t('ui.combine.add_user')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
          DebounceInput(
              size="sm"
              ref="dataAdd_userId"
              required
              alphaNum
              type="text"
              :dirty="$v.dataAdd_userId.$dirty"
              :error="$v.dataAdd_userId.$error"
              v-model.trim.lazy="$v.dataAdd_userId.$model"
              :disabled="loading"
              :maxLength="$v.dataAdd_userId.$params.maxLength.max"
          )
          ValidateResult(:value="$v.dataAdd_userId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')").mb-0
          DebounceInput(
              size="sm"
              required
              type="text"
              :dirty="$v.dataAdd_userName.$dirty"
              :error="$v.dataAdd_userName.$error"
              v-model.trim.lazy="$v.dataAdd_userName.$model"
              :disabled="loading"
              :maxLength="$v.dataAdd_userName.$params.maxLength.max"
          )
          ValidateResult(:value="$v.dataAdd_userName" :name="$t('ui.name')")
      b-form-group(:label="$t('ui.password')").mb-0
          DebounceInput(
              size="sm"
              required
              type="password"
              :dirty="$v.dataAdd_userPwd.$dirty"
              :error="$v.dataAdd_userPwd.$error"
              v-model.trim.lazy="$v.dataAdd_userPwd.$model"
              :disabled="loading"
              autocomplete="section-red new-password"
              :maxLength="$v.dataAdd_userPwd.$params.maxLength.max"
          )
          ValidateResult(:value="$v.dataAdd_userPwd" :name="$t('ui.password')")
      b-form-group(:label="$t('ui.combine.confirm_password')").mb-0
          DebounceInput(
              size="sm"
              required
              type="password"
              :dirty="$v.dataAdd_userPwdConfirm.$dirty"
              :error="$v.dataAdd_userPwdConfirm.$error"
              v-model.trim.lazy="$v.dataAdd_userPwdConfirm.$model"
              :disabled="loading"
              autocomplete="section-red new-password"
              :maxLength="$v.dataAdd_userPwd.$params.maxLength.max"
          )
          ValidateResult(:value="$v.dataAdd_userPwdConfirm" :name="$t('ui.combine.confirm_password')", :name2="$t('ui.password')")
      div.row
          div.col
              b-alert.animated.bounceIn(v-bind:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      i.fa.fa-ban
      span {{ $t("ui.cancel") }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
// ref
// https://forums.asp.net/t/918584.aspx?REGEX+password+must+contain+letters+a+zA+Z+and+at+least+one+digit+0+9
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_userId: "",
      dataAdd_userName: "",
      dataAdd_userPwd: "",
      dataAdd_userPwdConfirm: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_userId: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    dataAdd_userName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    dataAdd_userPwd: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    dataAdd_userPwdConfirm: {
      required,
      sameAs: sameAs("dataAdd_userPwd")
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addUserUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.user,
          user_id: this.dataAdd_userId,
          user_name: this.dataAdd_userName,
          password: this.dataAdd_userPwd
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_userId, this.dataAdd_userName);
                  this.$refs.addUser.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "add_user", this.feedback.status);
                  // this.$refs.addUser.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_userId = "";
      this.dataAdd_userName = "";
      this.dataAdd_userStatus = "all";
      this.dataAdd_userPwd = "";
      this.dataAdd_userPwdConfirm = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_userId.$el.focus();
    }
  }
};
</script>
